import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Dialog } from './dialog.model';

@Injectable({
    providedIn: 'root'
})
export class ModalDialogService {
    private dialog$ = new Subject<Dialog>();

    setModalDialog(newDialog: Dialog) {
        this.dialog$.next(newDialog);
    }

    getModalDialog(): Observable<Dialog> {
        return this.dialog$.asObservable();
    }
}
